// File: frontend/src/pages/Plato/config/platoConfigJson.js

// Original JSON configuration imported from the main config
export const platoConfigJson = {
  "parameters": {
    "word_count": {
      "type": "integer",
      "min": 50,
      "max": 1000,
      "step": 100,
      "default": 500
    },
    "tone": {
      "type": "object",
      "options": ["formal", "informal", "optimistic", "worried", "friendly", "curious", "assertive", "encouraging", "surprised", "cooperative", "humor"],
      "default": {},
      "values": [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
    },
    "style": {
      "type": "string",
      "options": ["descriptive", "narrative", "analytical", "persuasive", "expository", "system_default"],
      "default": "system_default"
    },
    "audience": {
      "type": "string",
      "options": ["system_default", "general", "actuary", "risk_manager", "asset_manager", "data_scientist", "software_engineer", "ml_researcher", "physicist", "mathematician", "economist", "cfo", "ceo"],
      "default": "system_default"
    },
    "purpose": {
      "type": "string",
      "options": ["inform", "persuade", "entertain", "analyze", "describe"],
      "default": "inform"
    },
    "structure": {
      "type": "string",
      "options": ["chronological", "compare_contrast", "problem_solution", "cause_effect", "list", "system_default"],
      "default": "system_default"
    },
    "keywords": {
      "type": "boolean",
      "default": false
    },
    "include_citations": {
      "type": "string",
      "options": ["none", "APA", "MLA", "Chicago", "Harvard", "system_default"],
      "default": "none"
    },
    "creativity_level": {
      "type": "number",
      "min": 0,
      "max": 1,
      "step": 0.1,
      "default": 0
    },
    "perspective": {
      "type": "string",
      "options": ["first_person", "second_person", "third_person", "system_default"],
      "default": "system_default"
    },
    "reasoning": {
      "type": "string",
      "options": ["coinductive_reasoning", "deductive_reasoning", "abductive_reasoning", "generalized_reasoning", "system_default"],
      "default": "system_default"
    }
  },
  "templates": [
    {
      "name": "Template 1",
      "parameters": {
        "word_count": 300,
        "tone": ["formal", 0.8],
        "style": "analytical",
        "audience": "actuary",
        "purpose": "inform",
        "structure": "problem_solution",
        "keywords": true,
        "include_citations": "APA",
        "creativity_level": 0.2,
        "perspective": "third_person",
        "reasoning": "deductive_reasoning"
      }
    },
    {
      "name": "Template 2",
      "parameters": {
        "word_count": 500,
        "tone": ["friendly", 0.6],
        "style": "narrative",
        "audience": "general",
        "purpose": "entertain",
        "structure": "chronological",
        "keywords": false,
        "include_citations": "none",
        "creativity_level": 0.7,
        "perspective": "first_person",
        "reasoning": "generalized_reasoning"
      }
    },
    {
      "name": "Template 3",
      "parameters": {
        "word_count": 800,
        "tone": ["assertive", 0.9],
        "style": "persuasive",
        "audience": "ceo",
        "purpose": "persuade",
        "structure": "compare_contrast",
        "keywords": true,
        "include_citations": "Harvard",
        "creativity_level": 0.5,
        "perspective": "second_person",
        "reasoning": "abductive_reasoning"
      }
    }
  ]
};